import { Icon, IconProps } from '@chakra-ui/react';

export function InternalPayflipLogoMark(props: IconProps): JSX.Element {
  return (
    <Icon
      data-testid="internal-payflip-logo-mark"
      width="101"
      height="102"
      viewBox="0 0 101 102"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      {...props}
    >
      <title>Payflip</title>
      <path
        d="M50 81.5C67.1208 81.5 81 67.6208 81 50.5C81 33.3792 67.1208 19.5 50 19.5C32.8792 19.5 19 33.3792 19 50.5C19 67.6208 32.8792 81.5 50 81.5Z"
        fill="#220A35"
      />
      <path
        d="M47.2822 39.9966C42.2294 39.9966 38.1301 45.3122 38.1301 47.7447V70.471H42.4622C45.1275 70.471 47.2822 68.3163 47.2822 65.651V39.9966Z"
        fill="url(#paint0_linear_1_79)"
      />
      <path
        d="M52.1698 30.5366H51.4416H51.4191H47.4399C42.9577 30.5366 39.2263 33.6974 38.3328 37.9169C38.2127 38.5025 38.1301 39.7187 38.1301 39.7187V47.4744C38.1301 47.4744 38.8809 42.782 44.8647 40.6572C46.4188 40.1092 48.0555 39.8464 49.7073 39.8464H50.1352H51.4266H51.4491H52.2374C54.7901 39.8464 56.8623 41.9186 56.8623 44.4712C56.8623 47.0239 54.7901 49.0961 52.2374 49.0961H51.4491H51.4266H50.1352H45.4653C41.4186 49.0961 38.1376 52.377 38.1376 56.4238V58.3983V70.3584C38.1376 70.3584 39.2263 59.1191 49.1217 58.3983H50.1352H51.4266H51.4491H52.1774C59.8729 58.3983 66.112 52.1593 66.112 44.4637C66.0969 36.7757 59.8654 30.5366 52.1698 30.5366Z"
        fill="url(#paint1_linear_1_79)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1_79"
          x1="38.1349"
          y1="55.2288"
          x2="47.2841"
          y2="55.2288"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0122996" stopColor="#FF2175" />
          <stop offset="0.0922144" stopColor="#FE287B" />
          <stop offset="0.6999" stopColor="#F95AA6" />
          <stop offset="1" stopColor="#F76DB6" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1_79"
          x1="44.2425"
          y1="50.4528"
          x2="64.974"
          y2="50.4528"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F9C5E7" />
          <stop offset="0.1468" stopColor="#FAB4DB" />
          <stop offset="0.439" stopColor="#FB86BC" />
          <stop offset="0.8456" stopColor="#FE3E89" />
          <stop offset="1" stopColor="#FF2175" />
        </linearGradient>
      </defs>
    </Icon>
  );
}
